export default {
  "copy_max_tip": "已达表单项数量上限，无法复制！",
  "copy": "复制",
  "add_item": "新增一条",
  "confirm_delete": "确定删除?",
  "confirm": "确定",
  "cancel": "取消",
  "operate": "操作",
  "delete": "删除",
  "edit": "编辑",
  "img_src_error": "图片地址错误",
  "upload": "上传",
  "upload_success": "上传成功",
  "upload_fail": "上传失败",
  "uploaded_address": "已上传地址",
  "test_src": "测试链接",
  "schema_not_match": "schema未匹配到展示组件：",
  "item": "项目",
  "search": "查询",
  "reset": "重置",
  "expand": "展开",
  "fold": "收起",
  "submit": "提交",
  "save": "保存",
  "moveDown": "下移",
  "moveUp": "上移"
};